import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
function getInitialTempReadonly() {
  const saved = localStorage.getItem('tempReadonly');
  return saved === 'true'; // 只有字符串 "true" 才返回 true
}

export default new Vuex.Store({
  state: {
    message: '', // 用于存储输入内容
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || null, // 从 localStorage 获取 userInfo
    token: localStorage.getItem('token') || null, // 从 localStorage 获取 token
    showLogin: false, // 控制登录框显示状态,
    accessType: localStorage.getItem('accessType') || null,
    isResponding: false,
    orderInfo: JSON.parse(localStorage.getItem('orderInfo')) || null,
    istrial: JSON.parse(localStorage.getItem('istrial')) || null,
    referer: '', // 存储用户来源信息
    customUiConfig: null, // 新增：存储UI配置数据
    sidebarExpanded:JSON.parse(localStorage.getItem('sidebarExpanded')) || true, // 左侧边栏是否展开
    previewExpanded: JSON.parse(localStorage.getItem('previewExpanded')) || false, // ChatPreview是否展开
    permission: false,
    tempReadonly: getInitialTempReadonly(), // 用于跨组件临时传递 readonly 状态
  },
  mutations: {
    setMessage(state, message) {
      state.message = message;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      if (userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo)); // 存储到 localStorage
      } else {
        localStorage.removeItem('userInfo'); // 清除 localStorage
      }
    },
    setToken(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('token', token); // 存储到 localStorage
      } else {
        localStorage.removeItem('token'); // 清除 localStorage
      }
    },
    setShowLogin(state, status) {
      state.showLogin = status;
    },
    setAccessType(state, accessType) {
      state.accessType = accessType;
      if (accessType) {
        localStorage.setItem('accessType', accessType); // 存储到 localStorage
      } else {
        localStorage.removeItem('accessType'); // 清除 localStorage
      }
    },
    setReadonly(state, tempReadonly) {
      state.tempReadonly = tempReadonly;
      localStorage.setItem('tempReadonly', String(tempReadonly)); // 存储到 localStorage
    },
    setPermission(state, permission){
      state.permission = permission;
      if (permission) {
        localStorage.setItem('permission', permission); // 存储到 localStorage
      } else {
        localStorage.removeItem('permission'); // 清除 localStorage
      }
    },
    setIsResponding(state, value) {
      state.isResponding = value;
    },
    setOrderInfo(state, orderInfo) {
      state.orderInfo = orderInfo;
      if (orderInfo) {
        localStorage.setItem('orderInfo', JSON.stringify(orderInfo)); // 存储到 localStorage
      }
    },
    setIstrial(state, istrial) {
      state.istrial = istrial;
      if (istrial) {
        localStorage.setItem('istrial', JSON.stringify(istrial)); // 存储到 localStorage
      }
    },
    setReferer(state, referer) {
      state.referer = referer;
      // if (referer) {
      //   localStorage.setItem('referer', referer); // 存储到 localStorage
      // }
    },
    setCustomUiConfig(state, config) {
      state.customUiConfig = config;
    },

    setSidebarExpanded(state, isExpanded) {
      state.sidebarExpanded = isExpanded;
      localStorage.setItem('sidebarExpanded', JSON.stringify(isExpanded));
    },
    setPreviewExpanded(state, isExpanded) {
      state.previewExpanded = isExpanded;
      localStorage.setItem('previewExpanded', JSON.stringify(isExpanded));
    },
  },
  actions: {},
  modules: {}
});
